module.exports = __webpack_public_path__ + "static/media/categories_step_2_1.ab3d40ea.svg";